import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import Image from "../components/image"
import SEO from "../components/seo"

const IndexPage = () => (
  <Layout>
    <SEO title="Online Events. Now More Alive!" />
    <h1>Create a more engaging online event and make more money from it!</h1>
    <p>Floorin is an upcoming web application that lets you create online events that mimic an in-person event.</p>
    <p>Make more money easily with out integrated payment solutions.</p>
    <div style={{ maxWidth: `300px`, marginBottom: `1.45rem` }}>
      <Image />
    </div>
  </Layout>
)

export default IndexPage
